





















/* eslint-disable no-return-await */
import '@/polyfills/custom-events';
import {
  useAsync, ref, defineComponent, onMounted, watch,
} from '@nuxtjs/composition-api';
import { Header, Footer } from '@rpl/menu';
import { throttle } from 'lodash-es';
import { PortalTarget } from 'portal-vue';
import { createNamespacedHelpers } from 'vuex-composition-helpers';

import apiUrls from '@/apiUrls.config.js';
import { pushPagePostTypeToDataLayer } from '~/helpers/data-layer/index';

import { UseRainbowContext } from '../context/RainbowContext';

const { useGetters } = createNamespacedHelpers('schowek');

export default defineComponent({
  name: 'DefaultLayout',
  components: {
    Header,
    Footer,
    PortalTarget,
  },
  provide: {
    SitemapCmpSettings: true,
  },
  setup() {
    const { $http, store, $cookies } = UseRainbowContext();
    // Tworzenie fake'owego contextu dla footer'a
    // W innym wypadku computed które wykonują commity wpadają w pętle
    const rCtx = { $cookies };
    const menu = useAsync(async () => await $http.$get(apiUrls.menu));
    const footer = useAsync(async () => await $http.$get(apiUrls.footer));
    const icons = ref({});
    const noScroll = ref(false);
    let scrollThrottled;
    let resizeThrottled;

    const { getSchowekIlosc } = useGetters(['getSchowekIlosc']);

    useAsync(async () => await store.dispatch('schowek/setSchowekIlosc'));

    if (process.client) {
      scrollThrottled = new CustomEvent('scrollThrottled', {
        detail: {
          getScrollPosition: () => window.pageYOffset,
        },
      });

      resizeThrottled = new CustomEvent('resizeThrottled');
    }

    const toggleNoScroll = () => {
      if (process.server) {
        return;
      }

      const $body = document.getElementsByTagName('body')[0];

      if (noScroll && $body) {
        $body.scrollTo && $body.scrollTo(0, 0);
        $body.classList.add('no-scroll');
      } else {
        $body.classList.remove('no-scroll');
      }
    };
    const resize = () => {
      document.dispatchEvent(resizeThrottled);
    };
    const scroll = () => {
      document.dispatchEvent(scrollThrottled);
    };
    const { useState: useStateRouting } = createNamespacedHelpers('routing');
    const { routeInfo } = useStateRouting(['routeInfo']);

    const onSitemapClick = (id: string) => {
      if (id !== 'cmp-settings') return;
      (window as any).cmp?._instance.exposed.openSettings();
    };

    onMounted(() => {
      if (process.client) {
        window.addEventListener('resize', throttle(resize, 30));
        document.addEventListener('scroll', throttle(scroll, 30));
      }
    });

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    watch(() => routeInfo.value, (curr, prev) => {
      pushPagePostTypeToDataLayer(curr?.SekcjaCache?.CzyTypKategoria ? 'category_page' : 'other_pages');
      // console.log('CURR CURR CURR ', curr);
    }, { immediate: true });

    return {
      noScroll,
      toggleNoScroll,
      scrollThrottled,
      resizeThrottled,
      icons,
      getSchowekIlosc,
      menu,
      footer,
      rCtx,
      onSitemapClick,
    };
  },
});
